import React from "react";
import OPOfflineIframe from "../../../iframe-component/operation-offline/OPOffIframe";

const Terminal = () => {
  return <OPOfflineIframe path="/operation/pushNotification" />;
};

export default React.memo(Terminal);
